import { Controller } from "@hotwired/stimulus"

/**
 * Filter archive pages by select taxonomy
 * 
 * The selected option's value attr will be the ?filter=[VALUE]
 * Set the filter name by adding data-filter=FILTER on the select element
 * Results in ?FILTER=VALUE
 */
export default class extends Controller {
	static targets = [ 'select', 'option' ];

	connect() {

        this.selectTarget.addEventListener('change', (evt) => {
            this.filter(evt);
        })

        this.checkFilter();
    }

    filter (evt) {
        const currentPage = '//' + location.host + location.pathname;

        if (evt.target.value === 'all') {
            window.location.href = currentPage;
        } else {
            window.location.href = currentPage + '?' + this.selectTarget.dataset.filter + '=' + evt.target.value;
        }
    }

    checkFilter() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const filter = urlParams.get(this.selectTarget.dataset.filter)
        
        if(filter) {
            this.selectTarget.value = filter;
        }
    }
}